import type { SVGProps } from "react";

export default function WarningHexagonIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10 6.45801V10.833"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5667 7.15035V12.8503C17.5667 13.7837 17.0667 14.6503 16.2584 15.1253L11.3084 17.9837C10.5001 18.4503 9.50008 18.4503 8.68342 17.9837L3.73338 15.1253C2.92505 14.6587 2.42505 13.792 2.42505 12.8503V7.15035C2.42505 6.21702 2.92505 5.35032 3.73338 4.87532L8.68342 2.01699C9.49175 1.55033 10.4917 1.55033 11.3084 2.01699L16.2584 4.87532C17.0667 5.35032 17.5667 6.20868 17.5667 7.15035Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.5V13.5833"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
